// extracted by mini-css-extract-plugin
export default {"bar":"VerticalScrollBar_bar__rZMPh","progress":"VerticalScrollBar_progress__MNVNb"};